import { PrincipalType } from '@lucidlink/dto/validation';
import { encryptCryptoKeyWithPublicKey } from '@lucidlink/ts-crypto/crypto';
import { isNotNil } from '@lucidlink/tscore';
import { prepareMemberCommon, } from './prepare-member-common';
export const prepareInvitedMember = async (params) => {
    const memberCommon = await prepareMemberCommon(params);
    const maybeMemberships = await Promise.all(params.groupIds.map(async (groupId) => {
        const { keys: groupKeys } = await params.principalsCrypto.verifyAndGetPrincipalKeys(groupId, {
            assertType: PrincipalType.GROUP,
        });
        if (!groupKeys) {
            return null;
        }
        return {
            groupId,
            eGroupPrivateKeyByMemberKey: await encryptCryptoKeyWithPublicKey(groupKeys.privateKey, memberCommon.memberKeys.encryptPair.publicKey),
        };
    }));
    const groupMemberships = maybeMemberships.filter(isNotNil);
    return { ...memberCommon.member, email: params.email, groupMemberships };
};
